enum ItemType {
	CATEGORY = "CATEGORY",
	PRODUCT = "PRODUCT"
}

enum Parametrics {
	COLOR = "color",
	SIZE = "shirtsize"
}

enum PageSlugs {
	PRODUCT = "product",
	CATEGORY = "category",
	PRODUCT_PAGE = "product-page",
	BLOG = "blog",
	BLOG_CATEGORY = "blog-category",
	ARTICLE = "article"
}

enum ComponentsRenderedInModal {
	ACCOUNT_LOGIN_FORM = "account",
	ACCOUNT_SIGN_UP_FORM = "account",
	ACCOUNT_RECOVER_PASSWORD = "account",
	ACCOUNT_WISHLIST = "account",
	STORE_AVAILABILITY = "Product"
}

enum CategoryUrlParams {
	FILTER = "filter",
	SORT = "sort",
	PAGE = "pageNo"
}

enum ProductFileCodes {
	DESCRIPTION_VIDEO = "description-video"
}

enum ProductPrefix {
	PACKAGE_PRODUCT = "package-product",
	SIMILAR_PRODUCTS = "similar-products"
}

enum BlogUrls {
	ARTICLE = "article",
	CATEGORY = "blog-category"
}

enum ProductTypes {
	BUNDLE = "ManagedStructure"
}

export {
	ItemType,
	Parametrics,
	PageSlugs,
	ComponentsRenderedInModal,
	CategoryUrlParams,
	ProductFileCodes,
	ProductPrefix,
	BlogUrls,
	ProductTypes
};
